<template>
    <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12>
                <div class="title primary--text">
                    <h4>{{ $t("enrollment.steps.ask_otp.component.title") }}</h4>
                </div>
                <div v-if="phone" class="py-3 subheading">
                    <h4 class="d-inline-block">{{ phone | confidential }}</h4>
                    <a class="primary--text" @click="goToStep(DEFINES.ENROLLMENT_STEPS.ASK_PHONE)">
                        {{ $t(`${eventPrefix}.change.label`) }}
                    </a>
                </div>
                <div class="subheading" v-html="$t('enrollment.steps.ask_otp.component.subtitle',{code:code})"></div>
            </v-flex>
            <v-flex xs12>
                <v-form ref="otpVerificationForm" onsubmit="return false;">
                  <v-layout justify-center align-center>
                    <CodeInput
                      ref="code"
                      style="direction: ltr"
                      :loading="false"
                      class="input py-4 secondary--text"
                      :fields="4"
                      type="number"
                      @complete="onComplete"
                    />
                  </v-layout>

                  <div class="pb-3">
                    <!-- Resend OTP -->
                    <div class="pt-0 text-xs-center subheading">
                      <span class="secondary--text">
                        {{ $t("enrollment.steps.ask_otp.no_otp") }}
                      </span>
                      <a @click="resendVerification(true)">
                        <strong class="primary--text">
                          {{ $t(`${eventPrefix}.resend_otp.label`) }}
                        </strong>
                      </a>
                    </div>
                    <!-- OR label -->
                    <div class="me-divider-break">
                      <h5 class="text-in-between-divider">
                        {{ $t(`${eventPrefix}.or.label`) }}
                      </h5>
                    </div>
                    <!-- Login with password -->
                    <div class="pt-0 text-xs-center">
                      <a @click="goToStep(DEFINES.ENROLLMENT_STEPS.ASK_PASSWORD)">
                        <strong class="primary--text subheading">
                          {{ $t(`${eventPrefix}.login_with_password.label`) }}
                        </strong>
                      </a>
                    </div>
                  </div>
                </v-form>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
            :class="[$vuetify.rtl ? 'ml-2' : '']"
            color="primary background--text"
            dark
            @click="onCancel"
            >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn>
            <v-btn
            :class="[$vuetify.rtl ? 'mx-0' : '']"
            color="primary background--text"
            dark
            @click="onConfirm"
            >{{ $t("enrollment.steps.verify.button") }}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
import CodeInput from "vue-verification-code-input";

export default {
    name:"EnrollmentAskOtpOnPhone",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        },
        phone:{
            default: null
        },
        code:{
            default: null
        },
    },
    components:{
        CodeInput
    },
    methods:{
        goToStep(step){
          this.$emit("onChange",step);
        },
        onComplete(otp){
          this.$emit("onSetCode",otp);
        },
        resendVerification(is_phone){
          this.$refs.code.values = ['','','','']
          this.$emit("onResend", is_phone)
        },
        onCancel(){
          this.$emit("onCancel");
        },
        onConfirm(){
          this.$emit("onConfirm");
        },
        validate(){
          return this.$refs.otpVerificationForm.validate();
        }
    }
}
</script>

<style>

</style>
